// Mobile-optimized particle configurations for different pages

export interface ParticleConfiguration {
  particleColors: string[];
  particleCount: number;
  particleSpread: number;
  speed: number;
  particleBaseSize: number;
  moveParticlesOnHover: boolean;
  alphaParticles: boolean;
  disableRotation: boolean;
  sizeRandomness: number;
}

// Configuration for LoginEmail page - subtle and elegant
export const loginEmailConfig: ParticleConfiguration = {
  particleColors: ['#ffffff', '#f8f9fa', '#e3f2fd'],
  particleCount: 1000,
  particleSpread: 20,
  speed: 0.5,
  particleBaseSize: 100,
  moveParticlesOnHover: false,
  alphaParticles: true,
  disableRotation: true,
  sizeRandomness: 0.3
};

// Configuration for LoginVerifyCode page - even more minimal
export const loginVerifyCodeConfig: ParticleConfiguration = {
  particleColors: ['#ffffff', '#f5f5f5'],
  particleCount: 1000,
  particleSpread: 6,
  speed: 0.02,
  particleBaseSize: 35,
  moveParticlesOnHover: false,
  alphaParticles: true,
  disableRotation: true,
  sizeRandomness: 0.2
};

// Detect if device is mobile for further optimization
export const isMobileDevice = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         window.innerWidth <= 768;
};

// Get optimized config based on device capabilities
export const getOptimizedConfig = (baseConfig: ParticleConfiguration): ParticleConfiguration => {
  if (isMobileDevice()) {
    return {
      ...baseConfig,
      particleCount: Math.floor(baseConfig.particleCount * 0.7), // Reduce by 30% on mobile
      speed: baseConfig.speed * 0.8, // Slower animation on mobile
      particleBaseSize: Math.floor(baseConfig.particleBaseSize * 0.9) // Slightly smaller particles
    };
  }
  return baseConfig;
};
